/* eslint-disable */
export default {
  confirmation: 'Confirmação',
  confirmMergeToConference: 'Adicionar a chamada de conferência?',
  mergeToConference: 'Unir',
  conferenceCall: 'Chamada de conferência',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
